import React from 'react';

function Header() {
  return (
    <header className="header">
      <div className="header-container">
        <div className="header-logo">
          <img src="/logo.png" alt="Jaat College of Education Logo" />
          <div>
            <h1>Jaat College of Education</h1>
            <span>Affiliated to Kurukshetra University | NCTE Approved</span>
          </div>
        </div>
        <nav>
          <ul className="nav-links">
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#activities">Activities</a></li>
            <li><a href="#affiliations">Affiliations</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
